import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.5 4.8q0-.8.9-.9h13.2a1 1 0 0 1 .6 1.5l-4.9 5v5.8a1 1 0 0 1-1.4.6l-3-3-.2-.5v-3l-5-4.9zm2.2.5 4.2 4.2.2.5v3l1.8 1.9V10l.2-.5 4.2-4.2z" })
});
export default SvgFilterRegularIcon;
